module.exports = __webpack_public_path__ + "static/img/img9.3d06c91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img9.jpg
// module id = 8f1j
// module chunks = 0